module.exports = __webpack_public_path__ + "img/pdf_inativo.f9e4daee.svg";